module.exports = __webpack_public_path__ + "556e22729e029522dc5f19ef61fe7690.svg";